import { ExpauseLoadingIndicator } from '@/presentation/components/common/loadingIndicators/ExpauseLoadingIndicator';
import { useTheme } from '@/presentation/contexts/ThemeContext';
import { useResponsiveDesign } from '@/presentation/responsiveDesign/responsiveDesign';
import { useLocale } from '@/presentation/contexts/LocaleContext';
import { qaAttr } from '@/presentation/utils/qaAttr';

type Variant = 'loading' | 'empty' | 'error';

interface LinkContentStatusViewProps {
  variant: Variant;
}

export const LinkContentStatusView = ({ variant }: LinkContentStatusViewProps) => {
  const { theme } = useTheme();
  const responsive = useResponsiveDesign();
  const { l10n } = useLocale();

  if (variant === 'loading') {
    return (
      <div
        {...qaAttr({ id: 'link-content-status', status: 'loading' })}
        style={{
          display: 'flex',
          justifyContent: 'center',
          padding: responsive.spacing['3xl'],
        }}
      >
        <ExpauseLoadingIndicator />
      </div>
    );
  }

  const isError = variant === 'error';
  return (
    <div
      {...qaAttr({ id: 'link-content-status', status: variant })}
      style={{
        textAlign: 'center',
        padding: responsive.spacing['3xl'],
        color: isError ? theme.danger : theme.text.secondary,
        fontSize: responsive.font.sm,
      }}
    >
      {isError ? l10n.common.unknownError : l10n.publish.linkContentEmpty}
    </div>
  );
};
